import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/benefits/pages/settings/RootPage'))

const BenefitsSettingsPage = React.lazy(() => import('modules/benefits/pages/settings/index'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.benefits.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'benefits'),
      },
      children: [
        {
          index: true,
          element: <BenefitsSettingsPage />,
        },
      ],
    },
  ]
}

export default settingsRoutes
